import React from "react";
import { Button, Icon, StatusBadge, Text } from "@zorni/components-lib";

import styles from "./TripPublicationTable.module.css";

const formatReferenceBadge = (reference) => {
  if (!reference) return "-";
  const clean = String(reference).startsWith("#")
    ? String(reference).slice(1)
    : String(reference);
  return `#${clean}`;
};

const mapTripStatusToBadge = (status) => {
  if (status === "PUBLISHED") {
    return { label: "Publié", type: "active", iconName: "iconCheck" };
  }

  if (status === "ARCHIVED") {
    return { label: "Archivé", type: "inactive", iconName: "iconPlugs" };
  }

  if (status === "WAITING_FOR_APPROVAL") {
    return { label: "En attente", type: "pending", iconName: "iconWarning" };
  }

  return { label: "Brouillon", type: "inactive", iconName: "iconPlugs" };
};

const TripPublicationTable = ({ trips, onOpenTrip, onEditTrip, onPublishTrip }) => {
  if (!trips.length) {
    return (
      <div className={styles.emptyState}>
        <Text size="sm" color="muted">
          Aucun circuit a afficher.
        </Text>
      </div>
    );
  }

  return (
    <div className={styles.tableWrapper}>
      <table className={styles.table}>
        <thead className={styles.thead}>
          <tr>
            <th>{"R\u00E9f"}</th>
            <th>Titre</th>
            <th>Etablissement</th>
            <th>Statut</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {trips.map((item) => {
            const status = mapTripStatusToBadge(item.status);
            const isPublished = item.status === "PUBLISHED";

            return (
              <tr key={item.id}>
                <td>
                  <Button
                    size="small"
                    variant="secondary"
                    label={item.trip?.reference || "-"}
                    onClick={() => onOpenTrip(item.id)}
                  />
                </td>
                <td>{item.trip?.title || "-"}</td>
                <td>{item.trip?.establishment?.company?.legalName || "-"}</td>
                <td>
                  <StatusBadge
                    iconName={status.iconName}
                    iconPosition="left"
                    label={status.label}
                    type={status.type}
                    size="small"
                  />
                </td>
                <td>
                  <div className={styles.actionsWrap}>
                    <button
                      type="button"
                      className={styles.iconBtn}
                      aria-label="Edit trip"
                      disabled={isPublished}
                      onClick={() => onEditTrip(item.id, item.tripId)}
                    >
                      <Icon name="iconPenToSquare" size="sm" />
                    </button>
                    <button
                      type="button"
                      className={styles.iconBtn}
                      aria-label="Publish trip"
                      disabled={isPublished}
                      onClick={() => onPublishTrip(item.id)}
                    >
                      <Icon name="iconCheck" size="sm" />
                    </button>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default TripPublicationTable;


